import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'umss-accordion-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accordion-content.component.html',
  styleUrls: ['./accordion-content.component.scss']
})
export class UmssAccordionContentComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** State props */
  @Input() isOpen: boolean = false;
  @Input() padding: 'None' | 'Small' | 'Regular' | 'Large' = 'Regular';
}
